import { useCallback, useEffect, useRef } from "react";

// This hook allows you to use a callback on a function that you are passing into a component
// instead of making sure that function is wrapped in a memo or callback, useCallbackRef will handle that for you
// NOTE: This hook should be used sparingly, and only when necessary
export function useCallbackRef<T extends (...args: any[]) => any>(
  callback: T | undefined,
  deps: React.DependencyList = []
) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(((...args) => callbackRef.current?.(...args)) as T, deps);
}
